import React from 'react';
import GwiApi from 'gwi-api';
import PropTypes from 'prop-types';
import Brick from './components/brick';
import BrickData from '../shared/helpers/brick-data';
import CONFIG from '../shared/helpers/config';
import Logger from '../shared/helpers/logger';

class App extends React.Component {
  static propTypes = {
    /* eslint-disable react/forbid-prop-types */
    queryParams: PropTypes.object,
    /* eslint-enable react/forbid-prop-types */
  };

  constructor(props) {
    super(props);

    Logger.debug('Booting up...');

    const queryParams = this.props.queryParams;
    const watchableId = queryParams.watchableId;
    const watchableType = queryParams.watchableType;

    Logger.debug('Received query params:', queryParams);

    let errorState = false;
    let promise;
    let brickData;

    if (watchableId && watchableType) {
      const api = new GwiApi(
          queryParams.apiKey,
          queryParams.authToken,
          CONFIG.apiHost,
      );

      if (BrickData.isValid(queryParams)) {
        Logger.debug('Valid Brick Data has been passed via query params. Will not query API.');

        brickData = BrickData.fromQueryParams(queryParams, api);

        promise = new Promise(resolve => resolve(brickData));
      } else {
        Logger.debug('Will query API for full Brick Data');

        promise = api.getBrick(watchableType, watchableId).then(response =>
            BrickData.fromApiResponse(response, api, queryParams),
        );
      }
    } else {
      errorState = true;
      throw Error('No Parameters Found in URL');
    }

    this.state = {
      loading: true,
      promise,
      error: errorState,
      brickData: undefined,
      watchableId,
      watchableType,
      userLoggedIn: true,
    };
  }

  componentDidMount() {
    if (this.state.promise) {
      this.state.promise.then((brickData) => {
        this.setState({ brickData });
      });
    }
  }

  renderBrick() {
    return (<Brick brickData={this.state.brickData} />);
  }

  render() {
    if (this.state.brickData) {
      return this.renderBrick();
    }

    return (<div className="loading" />);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/client/app.jsx